import { put, select, takeEvery } from 'redux-saga/effects';
import { Selectors, Types } from 'router';
import { Service } from 'sections/client-management/services';
import { Action } from 'store';
import { Actions as BrandConsentImportJobs } from '../consentImportJobs/byBrand';
import { Actions as SiteConsentImportJobs } from '../consentImportJobs/bySite';
import { Types as RestTypes } from '../genericAPIGatewayService/ducks';

function* loadImportJobs() {
  yield put(BrandConsentImportJobs.requestGetCollection({ clear: true }));
  yield put(SiteConsentImportJobs.requestGetCollection({ clear: true }));
}

function* loadImportJobsIfOnMarketingPermissionPage() {
  const isMarketingPermissionPage = yield select(Selectors.isMarketingPermissionPage);

  if (isMarketingPermissionPage) {
    yield loadImportJobs();
  }
}

const isSiteLoaded = (action: Action) =>
  action.type === RestTypes.GET_COLLECTION_COMPLETED && action.service === Service.Sites;

const isLocationChange = (action: Action) => action.type === Types.LOCATION_CHANGED;

export function* syncConsentImports() {
  yield takeEvery(isLocationChange, loadImportJobsIfOnMarketingPermissionPage);
  yield takeEvery(isSiteLoaded, loadImportJobsIfOnMarketingPermissionPage);
}
